export default __webpack_public_path__ + "static/media/Indiamap.262bab33.svg";